import { Maximize2, Minimize2, SquarePen } from 'lucide-react';
import { IconButton } from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface ChatHeaderActionsProps {
  expanded: boolean;
  onToggleExpanded: () => void;
  onNew: () => void;
  /** Whether there is nothing on screen to start over from. */
  isEmpty: boolean;
}

/** The drawer's own buttons beside its title: a new chat, and full screen. */
export function ChatHeaderActions({
  expanded,
  onToggleExpanded,
  onNew,
  isEmpty,
}: ChatHeaderActionsProps) {
  return (
    <>
      {/* Full screen has the sidebar's "Nieuwe chat"; two doors to one room confuse. */}
      {!expanded && (
        <IconButton aria-label={m.chat_new()} onClick={onNew} disabled={isEmpty}>
          <SquarePen size={16} aria-hidden='true' />
        </IconButton>
      )}
      <IconButton
        aria-label={expanded ? m.chat_collapse() : m.chat_expand()}
        onClick={onToggleExpanded}
        className='max-mobile:hidden'
      >
        {expanded ? (
          <Minimize2 size={16} aria-hidden='true' />
        ) : (
          <Maximize2 size={16} aria-hidden='true' />
        )}
      </IconButton>
    </>
  );
}
